export function isNumber(integer: number | string) {
  return integer === null ? false : Number.isNaN(+integer) === false;
}

export function removeCommaInValue(value: number | string): any {
  if (value) {
    return value.toString().replace(/,/g, "")
  }
  return value;
}